import { InjectionToken } from '@angular/core';

export const CLIMB_DIALOG_DATA = new InjectionToken<any>('ClimbDialogData');
